import { Link } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const FilterOption = styled(Link)`
  text-underline-offset: 5px;
`;
